export default [
  "bankruptcyBasics",
  "chapter7",
  "wageGarnishment",
  "propertyExemptions",
  "cars",
  "debts",
  "studentLoans",
  "upsolve",
  "consumerRights",
  "taxes",
  "chapter13",
  "court",
  "divorce",
  "covid",
  "chapter11",
  "news",
];
